module.exports = __webpack_public_path__ + "5dcf7ba7898a07c936563199eeb7d287.pdf";